import marked from 'marked'

/**
 * Removes emojis and other non-ASCII characters from text
 */
function removeEmojis (text) {
  // Remove emojis and other unicode symbols
  // This regex matches most emojis including:
  // - Emoticons (😀-😿, 😀-🙏)
  // - Dingbats (✂-➰)
  // - Transport and map symbols (🚀-🛿)
  // - Enclosed characters (🅰-🆚)
  // - Additional symbols (🈁-🈶, 🈚-🈺, 🉐-🉑)
  // - Flags (🇦-🇿)
  // - And other miscellaneous symbols
  return text.replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F1E0}-\u{1F1FF}]/gu, '')
}

export default function markdownToHtmlStringUtil (markdown) {
  if (!markdown) {
    return ''
  }

  // Remove <br /> tags and emojis before processing
  const cleanedMarkdown = removeEmojis(markdown.replace(/<br \/>/gi, '\n'))

  const html = marked(cleanedMarkdown)

  // Normalize multiple dashes in heading IDs to single dashes
  // This ensures IDs like "day-2--back--arms" become "day-2-back-arms"
  return html.replace(/id="([^"]*)"/g, (match, id) => {
    const normalizedId = id.replace(/-+/g, '-')
    return `id="${normalizedId}"`
  })
}
